var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_17598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_334_17598",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_334_17598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 21.75C13.9591 21.75 15.75 17.2728 15.75 11.75C15.75 6.22715 13.9591 1.75 11.75 1.75C9.54086 1.75 7.75 6.22715 7.75 11.75C7.75 17.2728 9.54086 21.75 11.75 21.75Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.75C21 14.2033 20.0254 16.556 18.2907 18.2907C16.556 20.0254 14.2033 21 11.75 21V22.5C14.6011 22.5 17.3354 21.3674 19.3514 19.3514C21.3674 17.3354 22.5 14.6011 22.5 11.75H21ZM11.75 21C9.29675 21 6.94397 20.0254 5.20926 18.2907C3.47455 16.556 2.5 14.2033 2.5 11.75H1C1 14.6011 2.13259 17.3354 4.1486 19.3514C6.16462 21.3674 8.89892 22.5 11.75 22.5V21ZM21.27 10.891C20.1538 11.6976 18.8818 12.2626 17.535 12.55C15.6415 13.0104 13.6986 13.2361 11.75 13.222V14.722C13.8237 14.736 15.8913 14.4946 17.906 14.003C19.4661 13.6631 20.9369 12.9976 22.222 12.05L21.27 10.891ZM11.75 2.5C14.1585 2.49984 16.4721 3.4391 18.1989 5.11811C19.9257 6.79711 20.9296 9.08343 20.997 11.491L22.497 11.45C22.4189 8.65176 21.2523 5.99435 19.2453 4.04285C17.2384 2.09135 14.5493 0.999691 11.75 1V2.5ZM20.997 11.491C20.997 11.577 20.997 11.6633 20.997 11.75H22.497C22.497 11.65 22.497 11.55 22.497 11.45L20.997 11.491ZM11.75 13.222C9.8014 13.2361 7.85847 13.0104 5.965 12.55C4.61823 12.2626 3.34617 11.6976 2.23 10.891L1.278 12.05C2.56344 12.9977 4.03454 13.6632 5.595 14.003C7.60936 14.4945 9.67659 14.736 11.75 14.722V13.222ZM2.5 11.75C2.5 11.6633 2.5 11.577 2.5 11.491L1 11.449C1 11.549 1 11.65 1 11.75H2.5ZM2.5 11.491C2.56745 9.08291 3.5717 6.79615 5.29916 5.11706C7.02661 3.43797 9.34097 2.49906 11.75 2.5V1C8.95084 0.999951 6.26205 2.09173 4.2553 4.0432C2.24855 5.99468 1.08212 8.65193 1.004 11.45L2.5 11.491Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_17598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.0e0ad42657c28af8607dbba7add16f63.svg";
export { ForwardRef as ReactComponent };